// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./assets/bundle." + chunkId + ".min.js?" + "5f01c3e4b8cc4ae1aeb5" + "";
};